<template>
  <div class="yeti-map" :style="{ 'background-image': 'url(' + currentPhase.mapImage + ')' }">
    <div
      v-html="currentPhase.messages[lang]"
      class="yeti-map__message">
    </div>

    <img
      :src="currentPhase.universityImage"
      class="yeti-map__uninversities"/>
  </div>
</template>

<script>
import Moment from "moment";

const imagesPath = require.context("../assets/images", true);

export default {
  name: "yeti-map",

  props: {
    lang: { type: String, required: true }, // Lang binded from parent.
  },

  data () {
    return {
      currentDate: Moment(),

      currentPhase: null,

      phases: [
        {
          endDate: "2017-09-14T23:59:59", // end: 14 septembre (23h59)
          messages: {
            en: "We're making<br/>new friends at",
            fr: "On va se faire<br/>des amis"
          },
          mapImage: imagesPath('./toronto-map.jpg', true),
          universityImage: imagesPath('./university-seneca.png', true)
        },

        {
          endDate: "2017-09-18T20:00:00", // end: 18 septembre (20h00)
          messages: {
            en: "We’re taking our<br/>yetirific selves to<br/>Montreal",
            fr: "On vient faire des<br/>rencontres gommidables<br/>à Montréal"
          },
          mapImage: imagesPath('./montreal-map.jpg', true),
          universityImage: imagesPath('./brb-phase.png', true)
        },

        {
          endDate: "2017-09-19T20:00:00", // end: 19 septembre (20h00)
          messages: {
            en: "We're making<br/>new friends at",
            fr: "On va se faire<br/>des amis"
          },
          mapImage: imagesPath('./montreal-map.jpg', true),
          universityImage: imagesPath('./university-concordia.png', true)
        },

        {
          endDate: "2017-09-20T20:00:00", // end: 20 septembre (20h00)
          messages: {
            en: "We're making<br/>new friends at",
            fr: "On va se faire<br/>des amis"
          },
          mapImage: imagesPath('./montreal-map.jpg', true),
          universityImage: imagesPath('./university-mcgill.png', true)
        },

        {
          endDate: "2017-09-26T20:00:00", // end: 26 septembre (20h00)
          messages: {
            en: "We’re taking our<br/>yetirific selves to<br/>Vancouver",
            fr: "On vient faire des<br/>rencontres gommidables<br/>à Vancouver"
          },
          mapImage: imagesPath('./vancouver-map.jpg', true),
          universityImage: imagesPath('./brb-phase.png', true)
        },

        {
          endDate: "2017-09-29T17:00:00", // end: 29 septembre (17h00)
          messages: {
            en: "We're making<br/>new friends at",
            fr: "On va se faire<br/>des amis"
          },
          mapImage: imagesPath('./vancouver-map.jpg', true),
          universityImage: imagesPath('./university-ubc.png', true)
        },

        {
          endDate: "2030-09-29T20:00:00", // Temporary contest ended state.
          messages: {
            en: "We’ll be back soon with your yetirific winner.",
            fr: "Le nom de notre gagnant sera annoncé sous peu."
          },
          mapImage: imagesPath('./vancouver-map.jpg', true),
          universityImage: null
        },
      ],
    }
  },

  created() {
    this.currentPhase = this.getCurrentPhase();
  },

  methods: {
    getCurrentPhase() {
      var currentPhase = null;

      this.phases.forEach((phase, index) => {
        if (this.currentDate.isBefore(phase.endDate)) {
          if (!currentPhase) {
            currentPhase = phase;
          }
        }
      });

      return currentPhase;
    }
  }
}
</script>



// WEBPACK FOOTER //
// YetiMap.vue?750a6090